import { Button, Grid, Typography } from "@mui/material"







export const TituloAndButtonAdd = ({ titulo='', titulo2='', onFunction=null, top, bottom, tamanio=15 }) => {


    return (


        <Grid item sx={{width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center', mt:top, mb:bottom}}>
            <Grid item xs={6} sm={4}>
                <Typography sx={{fontSize:`${tamanio}px`, fontWeight:'bold'}}>{ titulo }</Typography>
            </Grid>

            <Grid item xs={5} sm={4}>
                <Button variant='contained' fullWidth onClick={ onFunction } sx={{fontSize: '13px'}}>
                    { titulo2 }
                </Button>
            </Grid>
        </Grid>



    )



}
